import React, { useMemo } from "react";
import { HttpAttachment } from "tekkr-common/dist/model/attachments";
import { AttachmentReferenceType } from "tekkr-common/dist/enums";
import { SiGoogledocs, SiGoogleforms, SiGooglesheets, SiGoogleslides } from "react-icons/si";
import { FileIcon, LinkIcon } from "lucide-react";

interface AttachmentDisplay {
    type: string;
    url?: string;
    icon: React.ComponentType<{ className?: string }>;
}

export function useAttachmentDisplay(attachment: HttpAttachment): AttachmentDisplay {
    return useMemo(() => {
        if (attachment.reference.type === AttachmentReferenceType.File) {
            return {
                type: "File",
                url: undefined,
                icon: FileIcon,
            };
        }

        const isGoogleUrl = attachment.reference.url.includes("docs.google.com");
        if (isGoogleUrl) {
            if (attachment.reference.url.includes("/document/")) {
                return {
                    type: "Google Doc",
                    url: attachment.reference.url,
                    icon: SiGoogledocs as React.ComponentType<{ className?: string }>,
                };
            } else if (attachment.reference.url.includes("/spreadsheets/")) {
                return {
                    type: "Google Sheet",
                    url: attachment.reference.url,
                    icon: SiGooglesheets as React.ComponentType<{ className?: string }>,
                };
            } else if (attachment.reference.url.includes("/presentation/")) {
                return {
                    type: "Google Slides",
                    url: attachment.reference.url,
                    icon: SiGoogleslides as React.ComponentType<{ className?: string }>,
                };
            } else if (attachment.reference.url.includes("/forms/")) {
                return {
                    type: "Google Form",
                    url: attachment.reference.url,
                    icon: SiGoogleforms as React.ComponentType<{ className?: string }>,
                };
            }
        }

        return {
            type: "URL",
            url: attachment.reference.url,
            icon: LinkIcon,
        };
    }, [attachment]);
}
